const styles = {
  layout: {
    minHeight: "100vh",
  },
  header: {
    color: "#fff",
    textAlign: "center",
    fontSize: "3rem",
    background:
      "linear-gradient(90deg, rgba(246,83,39,1) 0%, rgba(147,27,252,.95) 50%, rgba(246,83,39,1) 100%)",
    height: "5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1",
  },
  image: {
    width: "45px",
  },
  title: {
    color: "white",
    margin: "0",
  },
  avatar: {
    color: "#f56a00",
    backgroundColor: "#fde3cf",
    marginRight: "6px",
  },
  userInfo: {
    position: "absolute",
    right: "25px",
    top: "20px",
    display: "flex",
    alignItems: "center",
  },
  login: {
    position: "absolute",
    right: "25px",
    top: "25px",
  },
  homeLink: {
    display: "flex",
    alignItems: "center",
  },
};
export default styles;
